module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Armchair-a7adc55a637012ace6b461d177dd0c4d.svg";